module.exports = __webpack_public_path__ + "img/logoside.1c0a9522.png";